import { getSubPieces } from "@/common/services/product.api";
import { IProduct } from "@/types/product.types";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";

import "./index.css";
import ModalCreateSubProduct from "../modals/CreateSubProduct";
import ModalInsertSubProduct from "../modals/InsertSubProduct";

export function ProductDashboard() {
  const params = useParams();
  const productId = params.productId || '';
  const [subPieces, setSubPiece] = useState<IProduct[]>([]);
  const [product, setProduct] = useState<IProduct>();
  const [showModalCreateSub, setShowModalModalSub] = useState(false);
  const [showModalInsertSub, setShowModalInsertSub] = useState(false);

  useEffect(() => {

    async function loadProduct() {
      const result = await getSubPieces(productId);
      setSubPiece(result.data.subpieces);
      setProduct(result.data.product);
    }
    if (!showModalCreateSub) {
      loadProduct();
    }

  }, [productId, showModalCreateSub]);

  const formatTypeProduct = (types: { Corretivo: boolean, Preventivo: boolean, "Mau Uso": boolean }) => {
    const values = Object.values(types);
    let text = "";
    Object.keys(types).map((type, i) => {
      if (values.filter(value => value).length > 1 && values[i]) {
        text = `${text} ${type}  |`
      } else if (values[i]) {
        text = type;
      }
    });
    text = text[text.length - 1] == "|" ? text.slice(0, text.length - 1) : text;
    return text == "" ? "Geral" : text;
  }

  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="mt-5 max-w-7xl w-full p-2">

        <div className="containerProduct">
          <div className="containerProductInfo">
            {product && <h2>{product.name}</h2>} - {product && <h2>{product.code}</h2>}
          </div>
          <ButtonWithLoader onClick={() => { setShowModalModalSub(true) }}>Criar Subitem</ButtonWithLoader>
          <ButtonWithLoader onClick={() => { setShowModalInsertSub(true) }}>Selecionar Subitem</ButtonWithLoader>
          <GenericTable
            data={subPieces || []}
            headers={{
              code: "Código",
              name: "Descrição",
              corrective: "Tipo de Peça"
            }}
            renders={
              {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                corrective: (_: any, _data) => {
                  const data = _data as IProduct;
                  return <p>{formatTypeProduct({ "Mau Uso": data.misuse, Corretivo: data.corrective, Preventivo: data.preventive })}</p>
                }
              }
            }
          >
          </GenericTable>
        </div>
      </section>
      {showModalCreateSub && <ModalCreateSubProduct onClose={() => setShowModalModalSub(false)} onSave={() => { }}></ModalCreateSubProduct>}
      {showModalInsertSub && <ModalInsertSubProduct onClose={() => setShowModalInsertSub(false)} onSave={() => { }}></ModalInsertSubProduct>}
    </div>
  )
}